import React from "react";
import { Languages } from "lucide-react";
import { useI18n } from "@/i18n";

export function LanguageToggle({ className = "" }) {
  const { lang, toggle } = useI18n();
  return (
    <button onClick={toggle} data-testid="language-toggle"
      className={`flex items-center gap-2 px-3 py-2 rounded-md text-sm font-medium text-zinc-300 border border-zinc-800 hover:border-[#00E5FF] hover:text-[#00E5FF] transition-colors ${className}`}>
      <Languages size={16} strokeWidth={1.5} />
      <span>{lang === "ar" ? "English" : "عربي"}</span>
    </button>
  );
}
